import storage from 'proxy-storage'
import store from 'utils/store/withMiddleware'
import { sendOnCloseEvent } from '../email/blueshift/implementations/on-close'
import { propAccessor } from '@hc-frontend/utils'

/**
 * @deprecated Use directly blueshift implementation. This function will be removed in future versions.
 */
export async function updateSessionContext(hcStorage) {
  const currentSessionId = propAccessor(hcStorage, 'session.sessionId')
  const lastSessionId = propAccessor(hcStorage, 'lastSessionId')

  if (currentSessionId !== lastSessionId) {
    if (typeof lastSessionId !== 'undefined' && lastSessionId)
      sendOnCloseEvent(lastSessionId) // onRefresh
    hcStorage.lastSessionId = currentSessionId
    storage.setItem('hc', hcStorage)
    store.update({ hcStorage }, true)
  }
}

/**
 * @deprecated Use directly blueshift implementation. This function will be removed in future versions.
 */
export async function updateSendSessionContext(hcStorage) {
  const currentSessionId = propAccessor(hcStorage, 'session.sessionId')
  const lastSessionId = propAccessor(hcStorage, 'lastSessionId')

  if (currentSessionId !== lastSessionId) {
    if (typeof lastSessionId !== 'undefined' && lastSessionId)
      sendOnCloseEvent(lastSessionId) // onRefresh
    hcStorage.lastSessionId = currentSessionId
    storage.setItem('hc', hcStorage)
    store.update({ hcStorage }, true)
  }
}
